<template lang="pug">
    div.row
        div.col-sm-12.voided-box(v-if="hasLoyalty")
            h6.text-center.block MESRA CARD APPROVED
    
            .row
                .col-sm-4
                    span eCard ID
                .col-sm-1
                    span :
                .col-sm-7.p-l-xs.text-right
                    span {{ maskCardNumber(receipt.loyalty.reference_number) }}
    
            .row(v-if='isEnableCds && receipt.loyalty.mobile_number !== null')
                .col-sm-4
                    span Mobile No
                .col-sm-1
                    span :
                .col-sm-7.p-l-xs.text-right
                    span {{ maskMobileNumber(receipt.loyalty.mobile_number) }}
    
            .row
                .col-sm-4
                    span Bonus Points
                .col-sm-1
                    span :
                .col-sm-7.p-l-xs.text-right
                    span {{ noDecimalNumber(receipt.loyalty.bonus_points) }}
    
            .row(v-if='isEnableCds')
                .col-sm-4
                    span Redeemed Points
                .col-sm-1
                    span :
                .col-sm-7.p-l-xs.text-right
                    span {{ noDecimalNumber(receipt.loyalty.redeemed_points) }}
    
            .row
                .col-sm-4
                    span Points Earned
                .col-sm-1
                    span :
                .col-sm-7.p-l-xs.text-right
                    span {{ noDecimalNumber(receipt.loyalty.earned_points) }}
    
            .row
                .col-sm-4
                    span New Balance
                .col-sm-1
                    span :
                .col-sm-7.p-l-xs.text-right
                    span {{ noDecimalNumber(receipt.loyalty.current_points) }}

            div(v-if="receipt.loyalty.upcoming_expiry_details && receipt.loyalty.upcoming_expiry_details.length > 0")
                div(v-for="(upcoming_expiry_detail, index) in receipt.loyalty.upcoming_expiry_details", :key="index")
                    div(v-if="index === 0")
                        .row
                            .col-sm-4
                                span Points Expiry
                            .col-sm-1
                                span :
                            .col-sm-7.p-l-xs.text-right
                                span {{ upcoming_expiry_detail.points + ' - ' + formatDate(upcoming_expiry_detail.expiry_date) }}
                    div(v-else)
                        .row
                            .col-sm-4
                                span
                            .col-sm-1
                                span
                            .col-sm-7.p-l-xs.text-right
                                span {{ upcoming_expiry_detail.points + ' - ' + formatDate(upcoming_expiry_detail.expiry_date) }}
    </template>

<script>
import { mapGetters } from 'vuex';
import receiptMixin from '../../mixins/receipt';
import formatMixin from '../franchise-inventory/format-mixin';
import Unleash from '@js/plugins/unleash';

export default {
    mixins: [receiptMixin, formatMixin],
    data() {
        return {
            isEnableCds: false,
        };
    },

    computed: {
        ...mapGetters('transaction', ['hasLoyalty', 'receipt']),
    },

    mounted() {
        this.enableUnleashCDS();
    },

    methods: {
        maskCardNumber(reference_number) {
            if (reference_number.includes('=')) {
                reference_number = reference_number.split('=')[0];
            }

            return (
                reference_number.substring(0, 6) +
                '.......' +
                reference_number.slice(-4)
            );
        },

        maskMobileNumber(mobile_number) {
            if (mobile_number) {
                return (
                    mobile_number.substring(0, 4) +
                    '...' +
                    mobile_number.slice(-4)
                );
            }

            return mobile_number;
        },

        enableUnleashCDS() {
            this.isEnableCds = Unleash.hasFeature('mesra_cardless_cds');
            return this.isEnableCds;
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/loyalty.vue